<div class="heading" *ngIf="!projectVolunteeringOffers || projectVolunteeringOffers?.length === 0">
  <img src="/assets/icons/no-volunteering.svg" alt="no-volunteering">
  <div class="heading-text">
    {{ "VOLUNTEERING_TAB.no_projects_volunteeringtab" | translate }}
  </div>
</div>

<div class="offers-container">
  <ng-container *ngFor="let projectVolunteering of projectVolunteeringOffers | slice : 0:paginationLimit">
    <app-volunteering-card
      [classes]="'ns-mb-20'"
      [currentLang]="currentLang"
      [offer]="projectVolunteering"
      [user]="this.user">
    </app-volunteering-card>
  </ng-container>
</div>

<ns-button (callback$)="navigateToAllOffers()"
           [classes]="'ns-font-26 ns-line-height-19 ns-height-63 ns-mt-70 ns-mb-70'"
           [styles]="(screenWidth < 767 ? 'width: calc(100vw - 40px);':'')+ ' margin:0 auto;'"
           [text]="'VOLUNTEERING_TAB.seeall_button_volunteeringtab' | translate"
           [type]="Constants.BUTTON_TYPE_DEFAULT_YELLOW_SOLID_M"
>
</ns-button>
